module.exports = __webpack_public_path__ + "img/extra1.3f18fd2b.jpg";